import _ from 'lodash'

export const optaService = {
  F40
}

async function F40 (optaCompetitionId, optaSeasonId, optaUser, optaPassword) {
  const requestOptions = {
    method: 'GET'
  }

  let result = await fetch(`https://cors.bridged.cc/http://omo.akamai.opta.net/competition.php?competition=${optaCompetitionId}&season_id=${optaSeasonId}&user=${optaUser}&psw=${optaPassword}&feed_type=F40&json`, requestOptions)
  result = await result.json()
  result = result.SoccerFeed.SoccerDocument.Team

  let teams = []

  for (let team of result) {
    let teamToBePushed = { players: [] }

    teamToBePushed.name = team.Name

    if (!_.isArray(team.Player) && team.Player) {
      let onlyPlayer = JSON.parse(JSON.stringify(team.Player))
      team.Player = []
      team.Player.push(onlyPlayer)
    }

    if (!team.Player) {
      team.Player = []
    }

    for (let Player of team.Player) {
      let playerToBePushed = { first_name: '', last_name: '', usual_name: '', number: 0, position: Player.Position }
      for (let Stat of Player.Stat) {
        if (Stat['@attributes'].Type === 'first_name') playerToBePushed.first_name = Stat['@value']
        if (Stat['@attributes'].Type === 'last_name') playerToBePushed.last_name = Stat['@value']
        if (Stat['@attributes'].Type === 'known_name') playerToBePushed.usual_name = Stat['@value']
        if (Stat['@attributes'].Type === 'jersey_num') playerToBePushed.number = Stat['@value'] === 'Unknown' ? 0 : Number(Stat['@value'])
      }
      teamToBePushed.players.push(playerToBePushed)
    }

    teams.push(teamToBePushed)
  }

  return teams
}



// WEBPACK FOOTER //
// ./src/services/opta.js